import { DataBean } from "../DataBean";

export class ProductLot extends DataBean {
    
    


    public async getProductLotCatalogByProduct(year:any,idProduct:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductLotCatalogByProduct_Number_Number", [year,idProduct]);
    }

    public async getProductLotCatalogByProductionOrder(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductLotCatalogByProductionOrder_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }
  

}